import { render, staticRenderFns } from "./WidgetLoader.vue?vue&type=template&id=41911076"
import script from "./WidgetLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetLoader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports